import { UserActionEnum } from '../enums/user-action.enum';

export class AbilityDto {
	action!: UserActionEnum;
	allow!: boolean;
}
